// Row 22 Test A (2026-10-01): while a queue callback rang, the left rail
// highlighted "Task" because, with no live display yet, the rail fell back to
// the last tab the agent had clicked. The ringing contact now owns the
// highlight: Streams' type 'task' -> Task, 'chat' -> Chat, anything else
// ('voice', 'queue_callback', unknown) -> Voice. A connected contact keeps the
// existing rule (TASK -> Task, otherwise Voice). Nothing live or ringing -> the
// agent's own tab choice.
export function typeOfContact(contact) {
  try { return String(contact?.getType?.() || '').toLowerCase(); } catch { return ''; }
}

export function railTab({ display, incomingContact, activeTab }) {
  if (display) return display?.meta?.channel === 'TASK' ? 'task' : 'voice';
  if (incomingContact) {
    const t = typeOfContact(incomingContact.contact);
    if (t === 'task') return 'task';
    if (t === 'chat') return 'chat';
    return 'voice';
  }
  return activeTab;
}
